const readConsentCookie = (): string | undefined => {
    const cookie = document.cookie.split(`; `).find((str) => str.startsWith(`vgw.device.consent.performance=`));
    return cookie ? cookie.split(`=`)[1] : undefined;
};

export const trackingBlocked = readConsentCookie() === 'block';
